import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { UtilsService } from '../../services/utils.service';
import { NotificationService } from '../../services/notification.service';
import { LanguagePipe } from '../../services/language.pipe';
import { KindsModalComponent } from '../kindsmodal/kindsmodal.component';
import { HistoryComponent } from '../history/history.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var InformationComponent = (function () {
    function InformationComponent(_data, _blogic, _utils, _notify, _lang, data, _modal) {
        this._data = _data;
        this._blogic = _blogic;
        this._utils = _utils;
        this._notify = _notify;
        this._lang = _lang;
        this.data = data;
        this._modal = _modal;
        this.counter = "00:00";
        this.enableTurnInformation = true;
        this.ccode = "";
        this.saveCcode = 0;
        this.maxTimeExceded = 0;
        this.clientName = "";
        this.clientDNI = "";
        this.clientObservations = "";
        this.clientDataAlert = false;
        this.showObservation = false;
        this.viewers = [];
        this.allCalls = [];
        this.destroy$ = new Subject();
    }
    InformationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._updateTurn(this._data.turn);
        this._data.turnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._updateTurn(response);
        });
        this.getViewers();
        this.getAllCalls();
        if (this._data.configuration['showViewerInfo']) {
            this.getAllCalls();
            setInterval(function () {
                _this.getAllCalls();
            }, 10000);
        }
    };
    InformationComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.interval);
        clearInterval(this.allCallsInterval);
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* When the turn information change */
    InformationComponent.prototype._updateTurn = function (turn) {
        var _this = this;
        this.showObservation = true;
        setTimeout(function () {
            _this.showObservation = false;
        }, 8000);
        clearInterval(this.interval);
        if (!this._data.turnIsActive()) {
            this.turn = null;
            this.ccode = "";
        }
        else {
            this.turn = turn;
            this.maxTimeExceded = 0;
            if (this._data.configuration["showCcodeInputMode"] == 1) {
                this.ccode = this.turn['ccode'];
            }
            else {
                this.ccode = this.turn['clientid'];
            }
            this.turn["twaiting"] = this._utils.getWaitTime(turn["initdatetime"], turn["deskdatetime"], false);
            this.animateTurn();
            this._initCounter();
        }
    };
    /* Init the attention time counter */
    InformationComponent.prototype._initCounter = function () {
        var _this = this;
        clearInterval(this.interval);
        var min = 0;
        var sec = 0;
        var send = 0;
        this.interval = setInterval(function () {
            sec++;
            if (sec == 60) {
                sec = 0;
                min++;
            }
            sec = "00" + String(sec);
            sec = sec.slice(sec.length - 2, sec.legth);
            min = "00" + String(min);
            min = min.slice(min.length - 2, min.legth);
            if (parseInt(min) + 1 == _this.turn["maxtime"]) {
                _this.maxTimeExceded = 1;
            }
            if (parseInt(min) >= _this.turn["maxtime"] && _this.turn["maxtime"] != 0) {
                _this.maxTimeExceded = 2;
                if (_this._notify.hasPermission() && send == 0) {
                    _this._notify.notify(_this._lang.transform("notifyTitleTimeExceded"), _this._lang.transform("notifyBodyTimeExceded"));
                    send++;
                }
            }
            _this.counter = min + ":" + sec;
        }, 1000);
    };
    /* Refresh the div for animate it */
    InformationComponent.prototype.animateTurn = function () {
        var _this = this;
        this.enableTurnInformation = false;
        setTimeout(function () {
            _this.enableTurnInformation = true;
        }, 0);
    };
    /* Open the atypes modal */
    InformationComponent.prototype.openAtypesModal = function () {
        this.kindsModal.openKindModal("atypesModal");
    };
    //  Si saveCcode = 1 quiere decir que está cargando la peticición, 0 muestra el botón de guardar y 2 muestra el check.
    InformationComponent.prototype.changeCcode = function () {
        var _this = this;
        this.saveCcode = 1;
        var params = {};
        if (this._data.configuration["showCcodeInputMode"] == 1) {
            params = {
                desk_id: this._data.session["desk"],
                turn_id: this._data.turn["id"],
                queue_id: this._data.turn["queue_id"],
                prekind: this._data.turn["prekind"],
                task: this._data.turn["task"],
                ccode: this.ccode,
                planhour: this._data.turn["planhour"],
                plandate: this._data.turn["plandate"]
            };
        }
        else {
            params = {
                desk_id: this._data.session["desk"],
                turn_id: this._data.turn["id"],
                queue_id: this._data.turn["queue_id"],
                prekind: this._data.turn["prekind"],
                task: this._data.turn["task"],
                clientid: this.ccode,
                planhour: this._data.turn["planhour"],
                plandate: this._data.turn["plandate"]
            };
        }
        this._blogic.setTicketInfo(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            if (_this._data.configuration["showCcodeInputMode"] == 2) {
                _this.turn["clientid"] = _this.ccode;
            }
            _this.saveCcode = 2;
            setTimeout(function () {
                _this.saveCcode = 0;
            }, 1500);
        });
    };
    InformationComponent.prototype.openClientData = function () {
        this.clientName = this.turn["clientname"];
        this.clientDNI = this.turn["clientid"];
        this.clientObservations = this.turn["rdcomment"];
        this._modal.show("clientDataModal");
    };
    InformationComponent.prototype.saveClientData = function () {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"],
            turn_id: this._data.turn["id"],
            queue_id: this._data.turn["queue_id"],
            prekind: this._data.turn["prekind"],
            task: this._data.turn["task"],
            clientid: this.clientDNI,
            clientname: this.clientName,
            rdcomment: this.clientObservations,
            planhour: this._data.turn["planhour"],
            plandate: this._data.turn["plandate"]
        };
        this._blogic.setTicketInfo(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.clientDataAlert = true;
            _this.turn["clientid"] = _this.clientDNI;
            _this.turn["clientname"] = _this.clientName;
            _this.turn["rdcomment"] = _this.clientObservations;
            setTimeout(function () {
                _this.clientDataAlert = false;
                _this._modal.hide("clientDataModal");
            }, 2000);
        });
    };
    InformationComponent.prototype.getViewers = function () {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"]
        };
        this._blogic.getViewers(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.viewers = response;
        });
    };
    InformationComponent.prototype.getTurnStatus = function (viewer, turn) {
        var i = 0;
        var status = "loading";
        for (var _i = 0, _a = this._data.turnStatusInViewer; _i < _a.length; _i++) {
            var e = _a[_i];
            if ((viewer == e["viewer"]) && (turn.id == e["turn_id"])) {
                if (e["result"] === true) {
                    status = "success";
                }
                if (e["result"] === false) {
                    status = "error";
                }
                break;
            }
            i++;
        }
        return status;
    };
    InformationComponent.prototype.getAllCalls = function () {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"]
        };
        this._blogic.getAllCalls(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.allCalls = response;
        }, function (err) { });
    };
    return InformationComponent;
}());
export { InformationComponent };
